<template>
    <v-row class="no-gutters justify-space-between mb-4">
        <v-col
            cols="12"
            class
        >
            <v-card
                outlined
                color="white"
                class="transaction"
                width="100%"
            >
                <v-row
                    class="align-center"
                    height="220px"
                    no-gutters
                >
                    <v-col
                        v-if="isUserAuthenticated"
                        class="d-flex flex-column align-center justify-center flex-shrink-1"
                        lg="3"
                        md="4"
                        cols="12"
                    >
                        <div class="ma-4 d-flex flex-column align-center justify-center">
                            <!-- TRANSACTION TYPE NEEDS FUNCTIONALITY -->
                            <div class="my-2">
                                <!-- 3po -->
                                <v-img
                                    v-if="order.type === '3po' && order.company && order.company.logo"
                                    width="150"
                                    contain
                                    :src="order.company.logo"
                                />

                                <div
                                    v-else
                                    class="text-center"
                                >
                                    <p
                                        class="overline mb-0"
                                        style="font-weight: 600 !important;"
                                        v-if="order.company"
                                    >
                                        {{  order.company.name }}
                                    </p>
                                    <v-row
                                        :style="{
                                            backgroundImage: `url('/svg/p2p-swap3.svg')`,
                                            width: '200px',
                                            height: '98px',
                                            justifyContent: 'center',
                                        }"
                                    >
                                        <v-img
                                            :src="order.company.logo"
                                            v-if="order.company && order.company.logo"
                                            contain
                                            class="hybrid-bank-logo"
                                        />
                                        <v-img
                                            :src="paymentMethodLogo"
                                            v-if="paymentMethodLogo"
                                            contain
                                            class="hybrid-bank-logo"
                                        />
                                        <v-img
                                            :src="bankLogo"
                                            v-if="bankLogo && bankLogoisAvailable"
                                            @error="bankLogoisAvailable = false"
                                            contain
                                            class="hybrid-bank-logo"
                                        />
                                    </v-row>

                                    <v-btn
                                        class="swap-button pa-4 my-1 text-none"
                                        depressed
                                        dark
                                    >
                                        P2P Swap
                                    </v-btn>

                                    <v-btn
                                        v-if="!!order.is_partial_match_allowed"
                                        class="swap-button d-block pa-4 my-1 text-none"
                                        depressed
                                        dark
                                        @click="showPartialMatchInfo = true"
                                    >
                                        Partial matching enabled
                                        <v-icon
                                            x-small
                                            right
                                        >
                                            mdi-help
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </div>

                            <!-- REVIEWS NEED FUNCTIONALITY -->
                            <!-- <v-row
                                class="flex-row flex-nowrap justify-center align-center py-2"
                                no-gutters
                            >
                                <div class="pa-2">
                                    <p class="subtitle-2 mb-0">
                                        4.81
                                    </p>
                                </div>
                                <div class="pb-1">
                                    <v-icon
                                        size="16"
                                        color="yellow darken-1"
                                    >
                                        mdi-star
                                    </v-icon>
                                    <v-icon
                                        size="16"
                                        color="yellow darken-1"
                                    >
                                        mdi-star
                                    </v-icon>
                                    <v-icon
                                        size="16"
                                        color="yellow darken-1"
                                    >
                                        mdi-star
                                    </v-icon>
                                    <v-icon
                                        size="16"
                                        color="yellow darken-1"
                                    >
                                        mdi-star
                                    </v-icon>
                                    <v-icon
                                        size="16"
                                        color="yellow darken-1"
                                    >
                                        mdi-star
                                    </v-icon>
                                </div>
                            </v-row> -->

                            <v-row
                                v-if="isYourOfferTag"
                                class="justify-center hidden-md-and-up"
                            >
                                <v-col cols="auto">
                                    <YourOfferTag :is-matcher="!isPoster" />
                                </v-col>
                            </v-row>

                            <v-btn
                                v-if="$_userCanAcceptOffers && $vuetify.breakpoint.mdAndUp"
                                color="primary"
                                dark
                                depressed
                                @click="$emit('transfer')"
                            >
                                Transfer
                            </v-btn>
                            <v-btn
                                v-else-if="!order.isNgHybrid &&$_userCanPostOffers && $vuetify.breakpoint.mdAndUp"
                                color="primary"
                                dark
                                depressed
                                @click="$emit('request')"
                            >
                                Request
                            </v-btn>

                            <v-btn
                                v-if="order.isNgHybrid && $_userCanPostOffers && $vuetify.breakpoint.mdAndUp"
                                color="primary"
                                dark
                                depressed
                                @click="$emit('transfer')"
                            >
                                Match
                            </v-btn>
                        </div>
                    </v-col>
                    <v-divider
                        v-if="isUserAuthenticated"
                        vertical
                        light
                        class="flex-shrink-1"
                        width="1px"
                        color="#f5f5f5"
                    />

                    <info-column
                        :order="order"
                        @show-fees="$emit('show-fees')"
                    />

                    <v-col
                        v-if="!isUserAuthenticated"
                        class="d-flex align-center justify-center py-5"
                    >
                        <v-btn
                            color="primary"
                            class="white--text"
                            dark
                            depressed
                            :to="{
                                name: 'login',
                                query: {
                                    redirectTo: $route.fullPath,
                                },
                            }"
                        >
                            Transfer
                        </v-btn>
                    </v-col>
                    <v-col
                        v-else-if="isUserAuthenticated && $vuetify.breakpoint.smAndDown"
                        class="text-center py-5"
                    >
                        <v-btn
                            v-if="$_userCanAcceptOffers"
                            color="primary"
                            dark
                            depressed
                            @click="$emit('transfer')"
                        >
                            Transfer
                        </v-btn>
                        <v-btn
                            v-else-if="!order.isNgHybrid && $_userCanPostOffers"
                            color="primary"
                            dark
                            depressed
                            @click="$emit('request')"
                        >
                            Request
                        </v-btn>
                        <v-btn
                            v-if="order.isNgHybrid && $_userCanPostOffers"
                            color="primary"
                            dark
                            depressed
                            @click="$emit('transfer')"
                        >
                            Match
                        </v-btn>
                    </v-col>
                    <!-- <v-divider
                        vertical
                        light
                        class="flex-shrink-1"
                        width="1px"
                        color="#f5f5f5"
                    /> -->

                    <!-- COUPON CODES NEED FUNCTIONALITY -->
                    <!-- <v-col
                        class="d-flex align-stretch justify-center flex-shrink-1"
                        lg="2"
                        md="3"
                    >
                        <div
                            v-if="order.fake"
                            class="ma-4 d-flex flex-column align-center justify-center"
                        >
                            <v-row
                                class="flex-row flex-nowrap justify-center align-center py-2"
                                no-gutters
                            >
                                <div width="120">
                                    <h4 class>
                                        10 Free Swaps Each Month
                                    </h4>
                                </div>
                            </v-row>
                            <v-hover v-slot:default="{ couponCodeExpand }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-chip
                                            class="justify-center flex-grow-1"
                                            label
                                            inactive
                                            v-on="on"
                                        >
                                            ASDFH123
                                        </v-chip>
                                    </template>
                                    <span>Expires {{ order.expires_at | moment('l') }} at {{ order.expires_at | moment('LT') }}</span>
                                </v-tooltip>
                            </v-hover>

                            <p class="blue-grey--text lighten-4 caption mb-0 mt-3">
                                Courtesy of:
                            </p>
                            <v-img
                                v-if="order.company && order.company.logo"
                                :src="order.company.logo"
                                width="120"
                                contain
                            />
                        </div>
                    </v-col> -->
                </v-row>

                <v-btn
                    class="mobile-info"
                    icon
                    color="primary"
                    @click="$emit('show-information')"
                    v-if="isUserAuthenticated && order.type !== '3po'"
                >
                    <v-icon>mdi-information</v-icon>
                </v-btn>
            </v-card>
        </v-col>

        <PartialMatchInfo
            v-model="showPartialMatchInfo"
            :order="order"
        />
    </v-row>
</template>
<script>
    import { mapGetters } from 'vuex';
    // import moment from 'moment-timezone'
    import InfoColumn from './list-item/info-column.vue';
    import YourOfferTag from './list-item/your-offer-tag.vue';
    import PartialMatchInfo from './partial-match-info.vue';
    import ServerUtils from '../../../services/ServerUtils';

    export default {
        name: 'TransfersListItem',
        components: {
            InfoColumn,
            YourOfferTag,
            PartialMatchInfo,
        },
        props: getProps(),
        computed: getComputed(),
        data() {
            return {
                bankLogoisAvailable: true,
                showPartialMatchInfo: false,
            };
        },
    };

    function getProps() {
        return {
            order: {
                type: Object,
                required: true,
            },
        };
    }

    function getComputed() {
        return {
            ...mapGetters([
                'isUserAuthenticated',
            ]),
            bankLogo,
            paymentMethodLogo,
            isPoster() {
                return this.$store.state.user.can_post_offers;
            },
            isYourOfferTag() {
                if (!this.$store.state.user.id) {
                    return false;
                }
                if (this.order.type !== 'p2p') {
                    return false;
                }
                return this.$store.state.user.id === this.order.user_id
                    || this.$store.state.user.id === this.order.posters_beneficiary_user_id;
            },
            isProduction() {
                return ServerUtils.isProduction();
            },
        };

        function paymentMethodLogo() {
            const {
                type,
                matcher_country: matcherCountry,
                matcher_currency: matcherCurrency,
                poster_payment_method_type: posterPaymentMethodType,
            } = this.order;

            if (type !== 'p2p') {
                return null;
            }

            if (ServerUtils.isDevOrLocal() && posterPaymentMethodType === 'kaoshi_test_payment') {
                this.$_getPaymentLogoPath('kaoshi_test_payment');
            }

            if (matcherCountry === 'US') {
                return this.$_getPaymentLogoPath('zelle_payment');
            }

            if (matcherCountry === 'GB') {
                return this.$_getPaymentLogoPath('faster_payment');
            }

            if (matcherCountry === 'CA') {
                return this.$_getPaymentLogoPath('interac_payment');
            }

            if (matcherCurrency === 'EUR') {
                return this.$_getPaymentLogoPath('sepa_payment');
            }

            return null;
        }

        function bankLogo() {
            const {
                poster_country: country,
                posterPaymentMethod,
                postersBeneficiaryDeliveryMethod
            } = this.order;

            console.log(this.order, postersBeneficiaryDeliveryMethod)

            if (postersBeneficiaryDeliveryMethod) {
                const { bankCode } = postersBeneficiaryDeliveryMethod
                if (!bankCode) {
                    return null
                }

                return `/images/banks/${country.toLowerCase()}/${bankCode}.png`;
            }

            if (!posterPaymentMethod) {
                return null;
            }

            const bankCode = posterPaymentMethod.bank_code;

            if (!bankCode) {
                return null;
            }

            return `/images/banks/${country.toLowerCase()}/${bankCode}.png`;
        }
    }
</script>

<style scoped>
.p2p-transfer {
    position: relative;
}

.p2p-transfer >>> .v-responsive.v-image.bank-logo {
    max-width: 70px;
    max-height: 70px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
}

>>> .v-responsive.v-image.hybrid-bank-logo {
    max-width: 40px;
    max-height: 70px;
    display: block;
}

.mobile-info {
    position: absolute;
    top: 0;
    right: 0;
}

.swap-button.v-btn {
    background: linear-gradient(90.55deg, #77C4DD 3.23%, #74DAC8 103.09%);
    font-weight: 600;
    letter-spacing: 0px;
    padding: 4px 6px !important;
    height: auto !important;
}
</style>
